/*
    Author: Vaishnavi
    Issue Description: Pop up button component 
*/
<template>
<button class="popupbtn" ref="tiBtn" type="button" v-on:click="$emit('click')" 
:class="type === 'primary' ? 'primary' : type === 'secondary' ? 'secondary' : type === 'ghost' ? 'ghost' : '' "> {{ text }}
</button>
</template>
<script>
export default {
  props: ["text", "type"],
};
</script>

